import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';

@Injectable({
  providedIn: 'root'
})
export class UserPickingsService extends ApiService{

  public pickUserAction (memId: string,payLoad:any): Observable<any> {
    return this.patch<any>(
      this.replacePathInfo(ROUTES.PICK_USER_ACTION, {
        memId: memId,
      }),{
        body: payLoad,
      }
    );
  }

  public pickUser (memId: string, payLoad:any): Observable<any> {
    return this.patch<any>(
      this.replacePathInfo(ROUTES.PICK_USER, {
        memId: memId,
      }),{
        body: payLoad,
      }
    );
  }
}

